import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as sha1 from 'sha1';
import { STORAGE_WHOLESALE_REDIRECT } from '../constants';
import { CustomerService } from '../customer.service';

@Component({
  selector: 'pv-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() redirect: string[];
  loginForm: FormGroup;
  submitted = false;
  message: string;

  constructor(
    private customerService: CustomerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      'email': new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      'password': new FormControl('', Validators.required)
    })
    if (this.customerService.loggedIn) {
      this.customerService.logout()
    }
  }

  get f() { return this.loginForm.controls }

  async onSubmit() {
    try {
      const response = await this.customerService.login(this.loginForm.get('email').value, sha1(this.loginForm.get('password').value.trim()))
      if (response.merged) {
        alert('The contents of your cart have changed')
        localStorage.removeItem(STORAGE_WHOLESALE_REDIRECT);
        this.router.navigate(response.merged ? ['/cart'] : (this.redirect || ['/profile']))
        return;
      }

      if (response.length) {
        console.warn(response)
        this.message = response
      } else {
        localStorage.removeItem(STORAGE_WHOLESALE_REDIRECT);
        this.router.navigate(response.merged ? ['/cart'] : (this.redirect || ['/profile']))
      }
    } catch(error) {
      console.error(error);
      this.message = 'Invalid email and password'
    }
  }
}
